import moment from "moment";

export default function() {
    return {
        items: {
            data: [],
            columns: [
                { name: 'Date Added', align: 'left', label: "Date Added", field: row =>moment(row.created_at).format("MMM Do YYYY"),  },
                { name: 'Coaching Session Number', align: 'left', label: "Coaching Session Number", field: row =>row.session_order_id,  },
                { name: 'Level of awareness and understanding of the topic prior to the session', align: 'left', label: "Level of awareness and understanding of the topic prior to the session", field: row =>row.beginning,  },
                { name:  'Level of awareness and understanding of the topic after session', align: 'left', label: "Level of awareness and understanding of the topic after session", field: row =>row.ending,  },
                { name: 'Shift', align: 'left', label: "Shift", field: row =>row.shift,  },
                { name: 'Session Rating', align: 'left', label: "Session Rating", field: row =>row.coaching_session_rating,  },
                { name: 'Coach Rating', align: 'left', label: "Coach Rating", field: row =>row.coach_rating,  },
                { name: 'Coachee comment on what was valuable', align: 'left', label: "Coachee comment on what was valuable", field:  row =>row.coachee_comment_on_session,  },
                { name: 'Coachee comment on what would make the session above an 8 out of 10', align: 'left', label: "Coachee comment on what would make the session above an 8 out of 10", field: row =>row.coachee_comment_on_valuable,  },
                { name: 'COACH RECOMMENDATION: To address coachee and below benchmark scores', align: 'left', label: "COACH RECOMMENDATION: To address coachee and below benchmark scores", field: row =>'hyperlink',  },
                { name: 'EI COMMENTS: In response to coach recommendations', align: 'left', label: "EI COMMENTS: In response to coach recommendations", field: row =>'hyperlink',  },

            ],
            pagination: {
                sortBy: '',
                descending: false,
                page: 1,
                rowsPerPage: 10,
                totalRecords: 0
            },
            filter: {
                search: "",
                customers: [],
                status: null,
                pickerDates: {
                    startDate: "",
                    endDate: "",
                },
                id: null
            },
            lastUpdated: '',
        },
        resData: {
            filter: {
                id: null
            },
        },

    }
}
